import { API } from './axios-config'

export default {
	sign_up: function (params, callback, error) {
		console.debug('sign_up')

		API.post('v1/user/sign-up', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	sign_in: function (params, callback, error) {
		console.debug('sign_in')

		API.post('v1/user/sign-in', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback(response.data)
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	sign_out: function (params, callback, error) {
		console.debug('sign_out')

		API.post('v1/user/sign-out', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback(response.data)
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	check_confirmation_code: function (params, callback, error) {
		console.debug('check_confirmation_code')

		API.post('v1/user/check-confirmation-code', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	forgot_password: function (params, callback, error) {
		console.debug('forgot_password')

		API.post('v1/user/forgot-password', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	},

	reset_password: function (params, callback, error) {
		console.debug('reset_password')

		API.post('v1/user/reset-password', params)
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				callback()
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	}
}
